export default __webpack_public_path__ + "static/claire_loes_resume-050f7fd3f769c3eef2ee1e8711d61a1c.pdf";